/**
 * Ryan O'Dowd
 * 2024-03-01
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
    },
    infoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 8,
    },
    infoText: {
      marginTop: 4,
      marginBottom: 4,
      color: colors.dialogText,
    },
  };
};

export default getStyles;
